import React, { useState } from "react";
import "./use-cases.css";
import icon from "../../assets/UseCasesSection/use-cases-icon.svg";
import usecaseImage1 from "../../assets/UseCasesSection/Financial Services.svg";
import usecaseImage2 from "../../assets/UseCasesSection/Healthcare.svg";
import usecaseImage3 from "../../assets/UseCasesSection/Retail.svg";
import usecaseImage4 from "../../assets/UseCasesSection/Manufacturing.svg";
import usecaseImage5 from "../../assets/UseCasesSection/Telecommunications.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";

export default function UseCases() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  const [activeTab, setActiveTab] = useState(0);
  const handleTabSwitch = (index) => {
    setActiveTab(index);
  };
  const tabLinks = [
    {
      category: "Financial Services",
      points: [
        {
          icon: icon,
          heading: "Fraud Detection & Secure Transactions",
          paragraph:
            "Prevent AI-driven financial fraud with real-time risk analysis and AI security controls.",
        },
        {
          icon: icon,
          heading: "Regulatory Compliance Automation",
          paragraph:
            "Ensure AI compliance with industry regulations like PCI-DSS and GDPR.",
        },
      ],
      image: usecaseImage1,
    },
    {
      category: "Healthcare",
      points: [
        {
          icon: icon,
          heading: "Secure AI-Powered Diagnosis",
          paragraph:
            "Mitigate risks in AI-assisted healthcare decisions with robust security frameworks.",
        },
        {
          icon: icon,
          heading: "Data Privacy & Security",
          paragraph:
            "Protect sensitive patient data with AI-powered security automation.",
        },
      ],
      image: usecaseImage2,
    },
    {
      category: "Retail",
      points: [
        {
          icon: icon,
          heading: "AI-Driven Fraud Prevention",
          paragraph:
            "Prevent e-commerce fraud and identity theft using AI risk mitigation strategies.",
        },
        {
          icon: icon,
          heading: "Secure AI-Powered Personalization",
          paragraph:
            "Protect AI recommendation models from adversarial attacks.",
        },
      ],
      image: usecaseImage3,
    },
    {
      category: "Manufacturing",
      points: [
        {
          icon: icon,
          heading: "Secure AI-Driven Quality Control",
          paragraph:
            "Protect AI-powered defect detection models from manipulation and adversarial inputs.",
        },
        {
          icon: icon,
          heading: "Supply Chain Security Enhancement",
          paragraph:
            "Mitigate risks in AI-powered logistics and forecasting systems.",
        },
      ],
      image: usecaseImage4,
    },
    {
      category: "Telecommunications",
      points: [
        {
          icon: icon,
          heading: "Network Security & AI Threat Detection",
          paragraph:
            "Enhance cybersecurity in AI-powered telecom networks and fraud detection systems.",
        },
        {
          icon: icon,
          heading: "AI Model Integrity in Personalized Services",
          paragraph:
            "Ensure safe and secure AI-driven customer interactions and service recommendations.",
        },
      ],
      image: usecaseImage5,
    },
  ];

  return (
    <section
      className={`use-cases-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="five"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>Use Cases</span>
          </div>
          <div className="heading-description">
            <h2>Enhancing AI Security Across Industries </h2>
            <p>
              Explore real-world applications showcasing how SAIF Aviator
              enhances AI security, ensuring trust, compliance, and resilience
              in critical sectors.
            </p>
          </div>
        </div>
        <div className="tab-switch-wrapper">
          <div className="tab-links-wrapper">
            {tabLinks.map((item, index) => (
              <div
                className={`${activeTab === index ? "active" : ""}`}
                onClick={() => handleTabSwitch(index)}
              >
                <p>{item.category}</p>
              </div>
            ))}
          </div>
          <div className="tab-switch-content-wrapper">
            {tabLinks.map((item, index) => (
              <div
                className={`tab-switch-content ${
                  activeTab === index ? "active" : ""
                } `}
                key={index}
              >
                <div className="tab-links">
                  {item.points.map((point, index) => (
                    <div key={index}>
                      <div className="tab-link-heading">
                        <img src={point.icon} alt="tab-icon" />
                        <div>
                          <h3>{point.heading}</h3>
                          <p>{point.paragraph}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="tab-switch-body">
                  <img src={item.image} alt="tab-switch-image" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
